import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-12 bg-background-dark" data-id="element-165">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-166">
        <FadeIn className="text-center mb-12" data-id="element-167">
          <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-blue-500/10 mb-6" data-id="element-168">
            <ShieldCheckIcon className="w-12 h-12 text-blue-500" data-id="element-169" />
          </div>
          <h2 className="text-2xl md:text-4xl font-black text-primary font-heading uppercase tracking-wider" data-id="element-170">
            GARANTÍA PACK BASES DEL ENTRENAMIENTO DE FUERZA — 7 DÍAS
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} className="mb-10" data-id="element-171">
          <div className="bg-card-dark border-2 border-primary rounded-3xl p-8 md:p-12 text-center shadow-[0_0_30px_rgba(217,95,2,0.15)]" data-id="element-172">
            <p className="text-xl md:text-2xl text-white mb-2 leading-relaxed" data-id="element-173">
              Abrís el pack. Revisás los 140 ejercicios. Los usás antes de tu
              próxima clase.
            </p>
            <p className="text-xl md:text-2xl text-white mb-8 leading-relaxed" data-id="element-174">
              Si en 7 días no es lo que esperabas:
            </p>

            <h3 className="text-4xl md:text-6xl font-black text-primary font-heading mb-8" data-id="element-175">
              Te devolvemos el 100%.
            </h3>

            <p className="text-xl md:text-2xl font-bold text-white uppercase tracking-wide notranslate" translate="no" data-id="element-176">
              Sin preguntas. Sin formularios. Sin drama.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} className="text-center max-w-3xl mx-auto" data-id="element-177">
          <p className="text-gray-400 italic leading-relaxed text-lg" data-id="element-178">
            La confianza que tenemos en el Pack Bases del Entrenamiento de
            Fuerza nos permite ofrecerte eso. El mismo compromiso para todos.
          </p>
        </FadeIn>
      </div>
    </section>;
}